import Rails from '@rails/ujs'

if (!window._rails_loaded) {
  Rails.start();
}

import * as bootstrap from 'bootstrap'
window.bootstrap = bootstrap 

import '~/javascripts/google_analytics_events.js'
import '~/javascripts/main.js'
import '~/javascripts/notifications.js'
import '~/javascripts/event_impression_tracker.js'
import '~/javascripts/header_search.js'
// Carousel arrows used to bind only inside discover.js, so every carousel outside
// the discover controller rendered dead buttons. See javascripts/carousel.js.
import '~/javascripts/carousel.js'
// Using optimized platform icon bundle (~135 icons) instead of all ~1000 icons
import '~/javascripts/lucide-icons-platform'
import '~/javascripts/advisor-call-modal.js'
// Shared saved ideas, sign-in and team-poll controls in the public header.
import '~/javascripts/planning-tools.js'
// Lazy card images fade in over their placeholder instead of popping.
import '~/javascripts/image-fade.js'
// Homepage-only, cache-safe personalization (geo tiles, company proof,
// shortlist strip, sticky CTA, exit intent). No-ops everywhere else.
import '~/javascripts/home_personalization.js'
import '~/javascripts/event_card_image_cropper'
import '~/javascripts/video_thumbnail_picker'
import '~/javascripts/vendor_onboarding_media_uploads'

import * as ActiveStorage from '@rails/activestorage'
ActiveStorage.start()

import swal from 'sweetalert'

// Maintain global access expected by legacy views.
window.sweetalert = swal
window.swal = swal
